import { PopUp } from "./pages/PopUp";
import AuthProvider from "./provider/authProvider";
import Routes from "./routes";
import { InstallProvider } from "./pages/InstallContext";

function App() {
  return (
    <AuthProvider>
      <InstallProvider>
        <div class="background1"></div>
        <Routes />
      </InstallProvider>
    </AuthProvider>
  );
}

export default App;

/*
// App.jsx
import { useInstallPrompt } from "./useInstallPrompt";

function App() {
  const installEvent = useInstallPrompt();

  return (
    <div>
      <h1>Hola mundo</h1>
      {installEvent ? (
        <button
          onClick={() => {
            installEvent.prompt();
            console.log("🛠️ Prompt de instalación disparado");
          }}>
          Instalar App
        </button>
      ) : (
        <p>❌ App no instalable aún</p>
      )}
    </div>
  );
}

export default App;
*/
